<template>
    <div class="col-12" id="credit_monitoring_step" :class="{'col-lg-3': userStore.user.isClient,'col-lg-5': !userStore.user.isClient}">
        <div class="card" :class="{ 'border-primary border-darken-1': $route.name == 'report' }">
            <div class="card-header mx-auto">
                <h3 class="card-title text-primary">Credit Monitoring</h3>
            </div>
            <div class="card-body">
                <p v-if="
                    email
                    &&
                    reportStore.reports[email]
                    &&
                    reportStore.reports[email].isReportFetch
                    &&
                    reportStore.reports[email].report.details
                ">
                    <strong> Credit Report Login: </strong>
                    <span
                        class="badge badge-glow badge-sm"
                        :class="reportStore.reports[email].report.details.credentials == reportStore.statusSuccess ? 'badge-success' : 'badge-danger'"
                    >
                        {{ reportStore.credentialStatus[reportStore.reports[email].report.details.credentials] }}
                    </span>
                    <br>
                    <span>
                        <strong>
                            Last Credit Pull Status:
                        </strong>
                        <span
                            class="badge badge-glow badge-sm"
                            :class="reportStore.reports[email].report.details.pull_status == reportStore.statusSuccess ? 'badge-success' : 'badge-danger'"
                        >
                            {{ reportStore.reportStatus[reportStore.reports[email].report.details.pull_status] }}
                        </span>
                    </span>
                    <br>
                    <strong>
                        Last Credit Pull Date:
                    </strong>
                    <span>
                        {{ formatDate(reportStore.reports[email].report.details.pull_date, 'LL') }}
                    </span>
                    <br>
                    <span v-if="reportStore.reports[email].report.details.pull_status == reportStore.statusSuccess">
                        <strong>
                            Next Available Credit Pull:
                        </strong>
                        <span v-html="daysDiffFromToday(reportStore.reports[email].report.details.report_date)">
                        </span>
                    </span>
                    <br>
                </p>
                <p v-else>
                    <strong>Credit Report Login:</strong>
                    <br />
                    <strong>Last Credit Pull Status:</strong>
                    <br />
                    <strong>Last Credit Pull Date:</strong>
                    <br />
                    <strong>Next Available Credit Pull:</strong>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import { useReportStore } from '../../stores/ReportStore.js'
import { useUserStore } from '../../stores/UserStore.js'
import moment from 'moment'
import { daysDiffFromToday, formatDate } from '../../utilities/_helpers'
export default {
    components: {
    },
    props: {
        clientEmail: {
            type: String,
            default: null
        }
    },
    setup() {
        return {
            reportStore: useReportStore(),
            userStore: useUserStore(),
            email: ref(null),
            daysDiffFromToday: daysDiffFromToday,
            formatDate: formatDate,
        }
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                if (!value.isBusinessUser) {
                    this.email = value.email;
                }
                else {
                    this.email = this.clientEmail;
                }
                if (!this.reportStore.reports[this.email]) {
                    this.reportStore.getReport();
                }
            }
        },
    },
    methods: {
    }
}
</script>
